import ApexChart from "./charts/TimeLineChart";

const LineaDeTiempo = () => {
  return (
    <div className="card">
      <div className="card-header pb-0">
        <h4 className="card-title d-inline-block">Línea de tiempo de salud</h4>{" "}
      </div>
      <ApexChart />
    </div>
  );
};

export default LineaDeTiempo;
